// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"232":"38e972f9","285":"d2c553cd","307":"f02dddad","453":"874d65d5","802":"3f066bfb"}[chunkId] + ".chunk.js";
};